import { Subject, Observable } from 'rxjs';
import { DestroyChecker } from 'app/helpers';
import { takeUntil, first } from 'rxjs/operators';

export abstract class ModalBaseComponent<T = any> extends DestroyChecker {
  loading$: Observable<boolean>;
  errors$: Observable<any>;
  private readonly _result$: Subject<false | T> = new Subject();

  readonly result$: Observable<false | T> = this._result$
    .asObservable()
    .pipe(takeUntil(this.destroyed$));

  closeModal(hasChanges?: T): void {
    this.loading$
      .pipe(first((loading) => !loading))
      .subscribe(() => this._result$.next(hasChanges || false));
  }

  submit(result: T) {
    this._result$.next(result);
  }
}
